<template>
    <div class="repairs">
        <div class="con">
            <div class="xin">
                <img :src="user.avatar" alt="" />
                <span>{{ user.nickname }}</span>
            </div>
            <div class="she">
                <div>
                    <span>姓名</span>
                    <input type="text" placeholder="姓名" v-model="user_data.user_name" />
                </div>

            </div>
            <div class="she">
                <div>
                    <span>联系电话</span>
                    <input type="number" placeholder="联系电话" v-model="user_data.phone" />
                </div>
            </div>
            <div class="she">
                <div>
                    <span>申请职位</span>
                    <input type="text" placeholder="申请职位" v-model="user_data.job" name="" id="" />
                </div>
            </div>
            <div class="pai">
                <span class="title">上传简历</span>
                <div class="imgBoxs">
                    <el-upload class="upload-demo" :action="url" :on-preview="handlePreview" :on-remove="handleRemove"
                        multiple :limit="1" :file-list="fileList" :headers="headers" drag accept=".pdf"
                        :on-success="unloadSuccess">
                        <i class=" el-icon-upload"></i>
                        <div class="el-upload__text"><em>点击上传</em></div>
                    </el-upload>
                </div>
            </div>
            <!-- <input type="datetime-local" name="start_time" autocomplete="off" placeholder="请输入上架开始时间" v-model="start_time"
                maxlength="100" @change="aaa" @click="bbb"> -->
        </div>
        <div class="ti">
            <button @click="submitPdf" class="btn">立即提交</button>
        </div>
    </div>
</template>
  
<script>

import pdf from "vue-pdf";// 引入pdf插件
import { submitPdfApi } from "@api/login";
import { getUserInfo } from "@api/user";

export default {
    components: {
        pdf
    },
    props: {},
    data() {
        return {
            user: { avatar: '', nickname: "" },
            // start_time: '2023-05-08T23:59:59',
            fileList: [],
            user_data: {
                user_name: '',
                phone: '',
                job: '',
                file_path: ""
            },
            // url: `${VUE_APP_API_URL}/upload/file`,
            url: `https://dggj.ccloud8.cn/api/upload/pdf`,
            headers: {
                "Authori-zation": "Bearer " + this.$store.state.app.token,
            },

        };
    },
    mounted() {

        getUserInfo().then((res) => {
            this.user = res.data;
            this.user_data.phone = res.data.phone;

        });

    },
    methods: {
        // bbb() {
        //     var today = new Date();//返回当前日期时间
        //     var yyyy = today.getFullYear();//获取当前年份
        //     var MM = today.getMonth() + 1;//因为getMonth()方法获取的是索引值,所以要＋1
        //     var dd = today.getDate();//返回一个月中的某一天
        //     // 2023 - 06 - 08T23: 00
        //     this.start_time = yyyy + ' - 05 - ' + dd + 'T23:59'
        //     // this.start_time=


        // },
        // aaa(e) {
        //     console.log(this.start_time)
        // },
        unloadSuccess(res) {
            console.log(res.data)
            this.user_data.file_path = res.data.url
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },

        submitPdf() {
            console.log(this.user_data)
            if (this.user_data.phone.length != 11) {
                return this.$dialog.error("请填写联系电话");
            }
            if (this.user_data.user_name.length == 0) {
                return this.$dialog.error("请填写姓名");
            }
            if (this.user_data.job.length == 0) {
                return this.$dialog.error("请填写申请职位");
            }
            if (this.user_data.file_path.length == 0) {
                return this.$dialog.error("请上传简历");
            }


            submitPdfApi(this.user_data)
                .then((res) => {
                    if (res) {
                        this.$dialog.success("提交成功");
                        this.user_data.user_name = '';
                        this.user_data.phone = '';
                        this.user_data.job = '';
                        this.user_data.file_path = '';
                        this.fileList = [];
                        setTimeout(() => { this.$router.push("/user"); }, 1000)


                    }
                })
                .catch((err) => {
                    this.$dialog.success(err.msg);
                    console.log(err);
                });
        },
    },
};
</script>
<style>
.el-upload-dragger {
    width: 100px !important;
    height: 80px !important;
}

.el-upload-dragger .el-icon-upload {
    margin: 0 0;
}

.el-upload__text {
    font-size: 0.28rem !important;
}

.el-icon-upload {
    font-size: 50px !important;

}
</style>
<style lang="scss" scoped>
.repairs {
    background-color: #f5f5f5;
    box-sizing: border-box;
    padding: 0.2rem;

    input {
        border: none;
    }

    .pictrue.uploadBnt {
        padding: 0.2rem 0.1rem;
        border: 0.02rem solid #ddd;

        div {
            color: #ccc;
        }
    }

    .con {
        width: calc(100vw - 0.4rem);
        background-color: white;
        box-sizing: border-box;
        padding: 0.2rem;

        img {
            width: 30px;
            border-radius: 50%;
            margin-right: 0.2rem;
        }

        .xin {
            display: flex;
            align-items: center;
            padding-bottom: 0.1rem;
            border-bottom: 0.02rem dashed #ccc;
        }

        .she {
            box-sizing: border-box;
            border-bottom: 0.02rem dashed #ccc;

            div {
                display: flex;
                width: 100%;
                padding: 4px 0;
            }

            span {
                display: inline-block;
                margin-right: 0.2rem;
            }

            input {
                flex: 1;
            }
        }

        .pai {
            display: flex;
            margin-top: 0.2rem;
            min-height: 70px;

            .title {
                display: inline-block;
                margin-right: 0.2rem;
            }

            .g-core-image-upload-btn {
                height: 61px;
                width: 61px;
                border: 1px solid #ccc;
                line-height: 61px;
            }

            .el-upload .el-upload--picture-card {
                background-color: #fbfdff;
                border: 0.02rem dashed #c0ccda;
                border-radius: 6px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 55px;
                height: 55px;
                cursor: pointer;
                line-height: 55px;
                vertical-align: top;
            }

            .imgBoxs {
                display: flex;


            }
        }

        .miao {
            margin-top: 0.2rem;
            display: flex;
            align-items: center;
            width: 100%;
            min-height: 76px;

            .input {
                flex: 1;
            }

            span {
                display: inline-block;
                margin-right: 0.2rem;
                white-space: nowrap;
                height: 76px;
            }

            textarea {
                min-height: 76px;
                width: 100%;
                border: 0.02rem dashed #ccc;
                color: #707070;
                box-sizing: border-box;
                padding: 0.2rem;
            }
        }

        .wei {
            height: 40px;
            line-height: 40px;
            margin-top: 0.2rem;
            width: 100%;
            display: flex;

            .input {
                flex: 1;
            }

            span {
                display: inline-block;
                margin-right: 0.2rem;
            }
        }

        // .bei {
        //   margin-top: 0.2rem;
        //   display: flex;
        //   align-items: center;
        //   width: 100%;
        //   display: flex;

        //   .input {
        //     flex: 1;
        //   }

        //   span {
        //     display: inline-block;
        //     margin-right: 0.2rem;
        //     white-space: nowrap;
        //     height: 70px;
        //   }

        //   textarea {
        //     height: 70px;
        //     // width: 100%;
        //     border: 0.02rem dashed #ccc;
        //     color: #707070;
        //     box-sizing: border-box;
        //     padding: 0.2rem;
        //   }
        // }

        // {
        //   margin-top: 10px;
        //   display: flex;
        //   align-items: center;
        //   flex-wrap: nowrap;

        //   span {
        //     margin-right: 0.2rem;
        //     display: block;
        //     // width: 78px;
        //     margin-right: 0.2rem;
        //     height: 55.6px;
        //   }

        //   textarea {
        //     padding: 10px;
        //     border: 0.02rem dashed #ccc;
        //     color: #707070;
        //     width: 100%;
        //   }
        // }
    }

    .ti {
        position: fixed;
        bottom: 0.4rem;
        width: calc(100vw - 0.4rem);

        button {
            width: calc(100vw - 0.4rem);
            margin: 0 auto;
            min-height: 30px;
            background-color: red;
            color: white;
            border-radius: 15px;
        }
    }
}
</style>
  